export default "__VITE_ASSET__23131605__"